import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import Store from "@/redux/store";
import { Provider } from "react-redux";
import Cart from "@/components/Header/Offcanvas/Cart";
import MobileMenu from "@/components/Header/MobileMenu";

import BreadCrumb from "@/components/Common/BreadCrumb";
import Separator from "@/components/Common/Separator";
import Gallery from "@/components/Gallery";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import FooterThree from "@/components/Footer/Footer-Three";

const GalleryPage = () => {
  return (
    <>
      <PageHead title="Gallery - Immigration Guru's"
        description="Photos from The Immigration Gurus education fairs, university visits, counselling sessions and student send-offs across our branch offices." />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <Cart />
          <BreadCrumb title="Gallery" text="Gallery" />

          <Gallery />

          <Separator />
          <FooterThree />
        </Context>
      </Provider>
    </>
  );
};

export default GalleryPage;
